import React, {CSSProperties} from 'react';

interface MultilineTextBoxProps {
  label?: string;
  name?: string;
  value: string | number;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  Component?: string;
  maxLength?: number;
  rows?: number;
  className?: string;
  style?: CSSProperties;
  required?: boolean;
}

const MultilineTextBox: React.FC<MultilineTextBoxProps> = ({
  label,
  name,
  value,
  onChange,
  error,
  touched,
  disabled,
  Component,
  maxLength,
  rows = 2,
  className = '',
  style = {},
  required = false,
}) => (
  <div className={`mb-0 ${className}`} style={style}>
    <div className='form-floating'>
      <textarea
        className={`form-control ${touched && error ? 'is-invalid' : ''}`}
        id={`txt${Component}${name}`}
        name={name}
        style={{minHeight: '65px'}}
        value={value}
        onChange={onChange}
        placeholder=' '
        disabled={disabled}
        maxLength={maxLength}
        rows={rows}
        required={required}
      />
      <label htmlFor={`txt${Component}${name}`}>
        {label}
        {!disabled && required && <span style={{color: 'red'}}>*</span>}
      </label>
      {touched && error && <div className='invalid-feedback'>{error}</div>}
    </div>
  </div>
);

export default MultilineTextBox;
